export const MARKET_PLAYERS_WITH_SEGMENTS_CONFIG_ID = "MarketPlayersSegments";
export const MARKET_PLAYERS_CONFIG_ID = "MarketPlayers";
export const MARKET_RESEARCH_WIDGETS_CONFIG_ID = "MarketResearchWidgets";
export const MARKET_RESEARCH_PERFORMANCE_WITH_SEGMENTS_CONFIG_ID = "MarketResearchOverviewWithSegments";
export const MARKET_RESEARCH_PERFORMANCE_CONFIG_ID = "MarketResearchOverview";

export const INDUSTRY_SEGMENTATION_CONFIG_ID = "IndustryAnalysisSegmentation";

export const MARKET_RESEARCH_HOME_CONFIG_ID = "WebMarketResearchOverviewHome";
